// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: "AIzaSyC0dR6YeABeOzztGI_VAc9G1g-gBZmvZ_I",
  authDomain: "talent-basket-2c367.firebaseapp.com",
  databaseURL: "https://talent-basket-2c367.firebaseio.com",
  projectId: "talent-basket-2c367",
  storageBucket: "talent-basket-2c367.appspot.com",
  messagingSenderId: "379894575386",
  appId: "1:379894575386:web:6f80a97e0be8fe95017ca3",
  measurementId: "G-LVT7JV7T3P"
};
// Initialize Firebase
// Guard against a missing `firebase` global: the CDN SDK (firebase-app.js)
// may be slow, fail, or be blocked (ad blockers / privacy extensions /
// corporate proxies), in which case it should degrade gracefully.
if (typeof firebase !== "undefined") {
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }
  // firebase-analytics.js is a separate script that blockers and crawlers
  // often drop while letting firebase-app.js through.
  if (typeof firebase.analytics === "function") {
    firebase.analytics();
  }
}
